import React from "react";
import { LocationSelectionModal } from "../modals/edit-location-modal/components/LocationSelectionModal";
import { MODAL_TYPES, ModalType } from "../../constants";
import { Location as LocationType, SpecialLocation, Group } from "../../types";

interface LocationSelectionModalWrapperProps {
  currentModal: ModalType;
  isModalOpen: (modalType: ModalType) => boolean;
  locations: LocationType[];
  orderedSpecialLocations: SpecialLocation[];
  groupsByLocationId: Record<number, Group[]>;
  onClose: () => void;
  onLocationSelect: (locationId: number) => void;
}

export const LocationSelectionModalWrapper = ({
  currentModal,
  isModalOpen,
  locations,
  orderedSpecialLocations,
  groupsByLocationId,
  onClose,
  onLocationSelect,
}: LocationSelectionModalWrapperProps) => {
  if (!isModalOpen(MODAL_TYPES.LOCATION_PICKER)) {
    return null;
  }

  return (
    <LocationSelectionModal
      open={currentModal === MODAL_TYPES.LOCATION_PICKER}
      onClose={onClose}
      onLocationSelect={onLocationSelect}
      locations={locations}
      specialLocations={orderedSpecialLocations}
      groupsByLocationId={groupsByLocationId}
    />
  );
};
